import { normalizeLocale } from "../translate.js";
import { LANDING_HIGHLIGHTS_BY_LOCALE } from "./highlights.js";
import { landingContentEn } from "./en.js";
import { landingContentNl } from "./nl.js";
import { LANDING_PAGE_ROUTES } from "./structure.js";

/** @type {Record<string, Record<string, import("./types.js").LandingPageContent>>} */
const CONTENT_BY_LOCALE = {
  nl: landingContentNl,
  en: landingContentEn,
};

export { LANDING_PAGE_ROUTES };

/**
 * @param {string} [locale]
 * @returns {import("./types.js").LandingPageContent & import("./structure.js").LandingPageRoute[]}[]
 */
export function buildLandingPages(locale) {
  const normalized = normalizeLocale(locale);
  const content = CONTENT_BY_LOCALE[normalized] ?? landingContentNl;

  return LANDING_PAGE_ROUTES.map((route) => ({
    ...route,
    ...content[route.slug],
  }));
}

/**
 * @param {string} [locale]
 * @returns {string[]}
 */
export function buildLandingHighlights(locale) {
  const normalized = normalizeLocale(locale);
  return LANDING_HIGHLIGHTS_BY_LOCALE[normalized] ?? LANDING_HIGHLIGHTS_BY_LOCALE.nl;
}

/**
 * @param {string} slug
 * @param {string} [locale]
 */
export function getLandingPageBySlug(slug, locale) {
  return buildLandingPages(locale).find((page) => page.slug === slug) ?? null;
}

/**
 * @param {string} path
 * @param {string} [locale]
 */
export function getLandingPageByPath(path, locale) {
  const match = LANDING_PAGE_ROUTES.find(
    (route) => route.paths.nl === path || route.paths.en === path,
  );
  if (!match) {
    return null;
  }

  return getLandingPageBySlug(match.slug, locale);
}
